import { Ref, forwardRef, useEffect, useState } from 'react';
import clsx from 'clsx';
import { Link, LinkPropsExt } from '../../components/link';
import { LinkText } from '../../components';

export interface TextLinkProps extends LinkPropsExt {
  className?: string;
  captionClassName?: string;
  caption: string;
}

const TextLinkComponent: React.ForwardRefRenderFunction<
  HTMLAnchorElement,
  TextLinkProps
> = (props: TextLinkProps, ref: Ref<HTMLAnchorElement>) => {
  const [tooltip, setTooltip] = useState<string>('');
  useEffect(() => {
    const newTooltip =
      props.tooltip && props.tooltip.length > 0 ? props.tooltip : props.caption;
    setTooltip(newTooltip);
  }, [props.caption, props.tooltip]);

  return (
    <Link
      ref={ref}
      className={clsx(props.className)}
      tooltip={tooltip}
      disabled={props.disabled}
      onClick={props.onClick}
      allowWrap={props.allowWrap}
    >
      <LinkText className={props.captionClassName} caption={props.caption} />
    </Link>
  );
};

const TextLink = forwardRef(TextLinkComponent);

export default TextLink;
